import LogoutUI from "../ui/LogoutUI";
import { useAppDispatch } from '../../store/hooks';
import { logout } from '../../store/thunk/auth';

export default function Logout(){
	const dispatch = useAppDispatch();

	function logoutUser(){
		console.log("Logged user out, maybe..");
		dispatch(logout());
	}

	return(
		<LogoutUI handleClick={logoutUser}/>
	);
}
